import React from 'react';
import YesNoQuestion from './QuestionTypes/YesNoQuestion';
import { Label } from 'reactstrap';
import RadioQuestion from './QuestionTypes/RadioQuestion';
import DropdownQuestion from './QuestionTypes/DropdownQuestion';
import MultipleChoiceQuestion from './QuestionTypes/MultipleChoiceQuestion';
import styles from './SurveyGroup.module.scss';

function questionToComponent(question) {
    switch (question.type) {
        case 'yesNo':
            return <YesNoQuestion {...question} />;
        case 'singleChoiceRadio':
            return <RadioQuestion {...question} />;
        case 'singleChoiceDropdown':
            return <DropdownQuestion {...question} />;
        case 'multipleChoice':
            return <MultipleChoiceQuestion {...question} />;
        default:
            return <div>Ups! Dieser Fragetyp existiert gar nicht!</div>;
    }
}

export default function SurveyGroup({ questions, style }) {
    if (questions.length === 1) {
        const question = questions[0];
        return (
            <div style={style} className={styles.SurveyQuestionCard}>
                <Label for={question._id} className={styles.SurveyGroupLabel}>
                    {question.title}
                </Label>
                <div className={styles.QuestionInputWrapper}>{questionToComponent(question)}</div>
            </div>
        );
    }

    return (
        <div style={style} className={styles.SurveyQuestionGroup}>
            {questions.map((question, index) => (
                <div key={index}>
                    <Label for={question._id} className={styles.SurveyGroupLabel}>
                        {question.title}
                    </Label>
                    {questionToComponent(question)}
                </div>
            ))}
        </div>
    );
}
